<template>
	<div class="guide-app">
	</div>
</template>
<script>
import JWT from "@/utils/jwt"
import router from "@/router"
import { APP_CONFIG } from '@/utils/constants'
export default {
  name: 'kiem-tra-xac-thuc',
  async created() {
    let uri = window.location.href.split('?');
    // eslint-disable-next-line no-constant-condition
    if(true) {
      let vars = uri[1].split('&');
      let getVars = {};
      let tmp = '';
      vars.forEach(function(v) {
        tmp = v.split('=');
        if(tmp.length == 2)
          getVars[tmp[0]] = tmp[1];
      });
    //   fetch("http://localhost:5000/api/signin-oidc?code="+getVars.code)
    // .then(( response ) => {
    //   if(!response) {return false;}
    //   console.log(response);
    //   console.log(response);
    //   JWT.saveToken(response.data.access_token, response.data.expired_in)
    //   if (response.userProfile) {
    //     if(response.userProfile.firstLogin) {
    //       router.push({ name: 'edit-user-profile' });
    //     } else {
    //       router.replace({ name: 'ebook', query: {book_active: "0", classes: 1} });
    //     }
    //   }
    //   // return response && response.userProfile ? response.userProfile : null;
    // })  

    if(getVars.code==undefined||getVars.code==null){
      router.push('/');
    }
    let urlReturn = getVars.urlReturn
    const request = await fetch(APP_CONFIG.dataUrl+"signin-oidc?code="+getVars.code+'&urlReturn=' + urlReturn);
    const response = await request.json();
    //console.log(response);
    if(response.data==null)
    {
      router.push('/');
    }
    let expired_in = (1 / 1440) *  parseFloat(response.data.expires_in);
      JWT.saveToken(response.data.access_token, expired_in);
      localStorage.setItem("refresh_token",response.data.refresh_token)

      if (response.data.userProfile) {
          JWT.saveAuth(response.data.userProfile);
        // if(response.data.userProfile.firstLogin) {
        //   // router.push({ name: 'edit-user-profile' });
        //   router.push({ name: 'user-profile' });
        // } else {
        //   router.replace({ name: 'ebook', query: {book_active: "0", classes: 1} });
        // }
        //console.log(getVars.urlReturn)
        window.location.replace(decodeURIComponent(urlReturn).replace('th98th','&'));
      }
    }
  },
}
</script>